import { API_BASE_URL, authFetch } from "./config";

export const fetchAllRecords = () => authFetch(`${API_BASE_URL}/records/`);

export const fetchallRecordsSingleUser = () => ({currentRecordId}) => {authFetch(`${API_BASE_URL}/records/${currentRecordId}/`)}

export const fetchMonthlyRevenue = () => authFetch(`${API_BASE_URL}/records/monthly-revenue/`);

export const fetchWeeklyRevenueAllUsers = () => authFetch(`${API_BASE_URL}/records/weekly-revenue/all-users/`);

export const fetchMonthlyStatsAllUsers = () => authFetch(`${API_BASE_URL}/records/monthly-revenue/all-users/`);

export const fetchMonthlyRevenueSingleUser = ({ currentUserId, filterSingle, filterSingleDateFrom, filterSingleDateTo }) => {
    const params = new URLSearchParams();
        params.append('filter', filterSingle);
        if (filterSingle === 'custom') {
            params.append('date_from', filterSingleDateFrom);
            params.append('date_to', filterSingleDateTo);
        }
        return authFetch(`${API_BASE_URL}/records/monthly-revenue/${currentUserId}/?${params}`);
}

export const exportToTelegram = ({ reportType, filter, userId, dateFrom, dateTo }) => {
    const params = new URLSearchParams();
        params.append('report_type', reportType);
        params.append('filter', filter);
        if (userId) params.append('telegram_id', userId);
        if (filter === 'custom') {
            params.append('date_from', dateFrom);
            params.append('date_to', dateTo);
        }
        return authFetch(`${API_BASE_URL}/records/export/telegram/?${params}`, { method: 'POST'});
}

export const createRecord = (data) =>
    authFetch(`${API_BASE_URL}/records/`, {
        method: 'POST',
        body: JSON.stringify(data)
    });

export const updateRecord = (id, data) =>
    authFetch(`${API_BASE_URL}/records/${id}/`, {
        method: 'PUT',
        body: JSON.stringify(data)
    });

export const deleteRecord = (id) => 
    authFetch(`${API_BASE_URL}/records/${id}/`, {method: 'DELETE' });
